module.exports = __webpack_public_path__ + "media/images/contest-label-left@3x-f85aa126943a16fd037a020fce6d204b.png";